/**
 * Color Cycle Container - Frontend Animation
 *
 * Speed values match mbm-gutenblocks animate format timing.
 *
 * The animate format cycle per word:
 *   1. Word visible for `interval` ms
 *   2. Transition out: ~0.3s × multiplier
 *   3. Transition in:  ~0.4s × multiplier
 *
 * Total cycle = interval + (700ms × multiplier)
 *
 * The color transition duration matches the text transition window
 * (0.7s × multiplier) so the color shifts while the text changes.
 */

const SPEED_MAP = {
	slow:   { multiplier: 1.5, interval: 3000 },
	normal: { multiplier: 1,   interval: 2000 },
	fast:   { multiplier: 0.5, interval: 1200 },
};

const BLOCK_SELECTOR = '.wp-block-amp-child-theme-color-cycle-container';

function initCrossfade(element, colors, { interval, multiplier }) {
	let colorIndex = 0;

	// Transition duration matches the text out+in window (0.7s × multiplier)
	const transitionDuration = 700 * multiplier;

	// Total cycle = hold time + transition time (matches text animate cycle)
	const cycleInterval = interval + transitionDuration;

	element.style.transition = `background-color ${transitionDuration}ms ease`;

	setInterval(() => {
		colorIndex = (colorIndex + 1) % colors.length;
		element.style.backgroundColor = colors[colorIndex];
	}, cycleInterval);
}

function initGradient(element, colors, { interval, multiplier }) {
	if (colors.length < 2) return;

	// Build a looping gradient with the first color repeated at end
	const gradientColors = [...colors, colors[0]];
	const gradient = `linear-gradient(135deg, ${gradientColors.join(', ')})`;

	// Size the background large enough to animate through all colors
	const sizePct = gradientColors.length * 100;
	element.style.background = gradient;
	element.style.backgroundSize = `${sizePct}% ${sizePct}%`;

	// Total cycle per color matches the text animate cycle
	const transitionDuration = 700 * multiplier;
	const cyclePerColor = interval + transitionDuration;
	const totalDuration = cyclePerColor * colors.length;

	element.style.animation = `colorCycleGradient ${totalDuration}ms ease infinite`;
}

function initColorCycleContainers() {
	const containers = document.querySelectorAll(BLOCK_SELECTOR);

	containers.forEach((container) => {
		let colors;
		try {
			colors = JSON.parse(container.dataset.colors);
		} catch {
			return;
		}

		if (!Array.isArray(colors) || colors.length < 2) return;

		const speed = container.dataset.speed || 'normal';
		const animationStyle = container.dataset.animationStyle || 'crossfade';
		const speedSettings = SPEED_MAP[speed] || SPEED_MAP.normal;

		if (animationStyle === 'gradient') {
			initGradient(container, colors, speedSettings);
		} else {
			initCrossfade(container, colors, speedSettings);
		}
	});
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initColorCycleContainers);
} else {
	initColorCycleContainers();
}
